const smartContractFeesPath = '/smart-contract-fees';

export class DefaultSmartContractRulePath {
  static smartContractFees() {
    return smartContractFeesPath;
  }
}
